export default {"src":"https://fishbrain.com/_next/static/media/idaho.03c7829f.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};